'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.BidRemote = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _helpers = require('./helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var transformResponse = function transformResponse(body) {
    return {
        currentBid: body.current_bid,
        isCurrentHighBid: body.is_current_high_bid,
        isReserveMet: body.is_reserve_met,
        leadingBid: body.leading_bid,
        success: body.success
    };
};

var BidRemote = exports.BidRemote = {
    postPlaceAbsenteeBid: function postPlaceAbsenteeBid(_ref) {
        var authToken = _ref.authToken,
            deployment = _ref.deployment,
            details = _ref.details;

        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makePost)('<MAINHOST-API>api/abs_bid', deployment);
            (0, _helpers.addAuthToken)(request, authToken);
            request.type('form');
            request.send({
                accept_terms: true,
                bid: details.bidAmount,
                cat_id: details.catalogId,
                lot_id: details.itemId
            });
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)(resolve, reject, err, response, transformResponse);
            });
        });
    },
    postPlaceLiveBid: function postPlaceLiveBid(_ref2) {
        var authToken = _ref2.authToken,
            bidAmount = _ref2.bidAmount,
            deployment = _ref2.deployment,
            itemId = _ref2.itemId;

        return new _promise2.default(function (resolve, reject) {
            var message = 'placedBid for ' + bidAmount + ' on lot ' + itemId;
            console.log(message);
            resolve({ message: message });
            // const request = makePost('<MAINHOST-API>api/live_bid', deployment);
            // addAuthToken(request, authToken);
            // request.type('form');
            // request.send({
            //     accept_terms: true,
            //     bid: details.bidAmount,
            //     cat_id: details.catalogId,
            //     lot_id: details.itemId,
            // });
            // request.end((err, response) =>
            //     handleResponse(resolve, reject, err, response, transformResponse)
            // );
        });
    },
    postRetractBid: function postRetractBid(_ref3) {
        var authToken = _ref3.authToken,
            bidderId = _ref3.bidderId,
            deployment = _ref3.deployment,
            itemId = _ref3.itemId,
            retractionExplanation = _ref3.retractionExplanation,
            retractionReason = _ref3.retractionReason;

        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makePost)('<MAINHOST-API>api/bidders/' + bidderId + '/biditems/' + itemId + '/retract', deployment);
            (0, _helpers.addAuthToken)(request, authToken);
            request.send({
                retractionExplanation: retractionExplanation,
                retractionReason: retractionReason
            });
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)(resolve, reject, err, response);
            });
        });
    }
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/api/remote/bid.js
// module id = 2+GA
// module chunks = 46